module.exports = __webpack_public_path__ + "static/democracy-and-dictatorship-in-europe-9eff5f63d8d8ede698323e35ec6d75f0.jpg";